<div class="center-wrapper">
<div class="profile-info-card">
  <div class="header">
   <div class="title-with-icon">
      <img *ngIf="!isEditMode" routerLink="/settings" src="assets/images/leftArrow.png"/>
      <img *ngIf="isEditMode" (click)="toggleEdit()" src="assets/images/leftArrow.png"/>
      <h3>Profile Information</h3>
    </div>
    <p class="subtitle" *ngIf="!isEditMode">Keep your profile information updated</p>
    <p class="subtitle" *ngIf="isEditMode">Update your personal information and profile photo</p>

    <div class="btn-with-icon" style="cursor: pointer;">
      <!-- <i class="bi bi-info-circle"></i> -->
      <!-- <button class="icon-btn" appTooltip [tooltipTitle]="'Tooltip Title'"
        [tooltipText]="'Tooltips display informative text when users hover over, focus on, or tap an element.'"
        [tooltipPlacement]="'right'">
        <i class="bi bi-info-circle"></i>
      </button> -->
    </div>

  </div>
  <hr />

  <!-- View Mode -->
    <div class="profile-section" *ngIf="!isEditMode">
      <div class="profile-pic-container">
        <ng-container *ngIf="profileImg; else noImg">
          <img [src]="profileImg" alt="Profile Image" class="profile-pic" />
        </ng-container>
        <ng-template #noImg>
          <div class="profile-placeholder">
            {{ profileData?.first_name?.charAt(0)?.toUpperCase() }}
          </div>
        </ng-template>
        <div class="edit-icon">
          <input type="file" #fileInput style="display: none" (change)="onFileChanged($event)"/>
          <i class="bi bi-pencil-fill" (click)="changePhoto(fileInput)"></i>
        </div>
      </div>

      <h4 class="username">{{ profileData?.first_name }} {{ profileData?.last_name }}</h4>
      <p class="email">{{ profileData?.email }}</p>

      <button class="edit-btn" (click)="toggleEdit()" *ngIf="!isEditMode">Edit Profile</button>
    </div>

    <div class="info-grid" *ngIf="!isEditMode">
      <div class="info-item">
        <label class="info-label">First Name</label>
        <p>{{ profileData?.first_name }}</p>
      </div>
      <div class="info-item">
        <label class="info-label">Last Name</label>
        <p>{{ profileData?.last_name }}</p>
      </div>
      <div class="info-item">
        <label class="info-label">Gender</label>
       <p>{{ (profileData?.gender | titlecase) || 'NA' }}</p>
      </div>
      <div class="info-item">
        <label class="info-label">Email</label>
        <p>{{ profileData?.email }}</p>
      </div>
      <div class="info-item">
        <label class="info-label">Date Of Birth</label>
        <p>{{ profileData?.dob ? (profileData.dob | date:'dd/MM/yyyy') : 'NA' }}</p>
      </div>
      <div class="info-item">
        <label class="info-label">Phone Number</label>
        <p>{{ profileData?.mobile || 'NA' }}</p>
      </div>
      <div class="info-item">
        <label class="info-label">Password</label>
        <p>********</p>
      </div>
    </div>
  <!-- View Mode -->


  <!-- Edit Mode -->
    <div class="profile-photo-section edd" *ngIf="isEditMode">
      <div class="photo-wrapper">
        <div class="photo-container">
          <ng-container *ngIf="profileImg; else noImage">
            <img [src]="profileImg" alt="Profile" class="profile-img" />
          </ng-container>
          <ng-template #noImage>
            <div class="placeholder-img">
              {{ profileData?.first_name?.charAt(0)?.toUpperCase() }}
            </div>
          </ng-template>   

          <!-- Profile with camera icon -->
          <div class="profile-photo-container">
            <!-- <img [src]="profileImage || 'assets/default-avatar.png'" class="profile-photo" /> -->
            <div class="camera-icon" (click)="openCamera()">
              <i class="bi bi-camera-fill"></i>
            </div>
          </div>
          <!-- Camera modal -->
          <div *ngIf="showCamera" class="camera-modal">
            <video #video autoplay></video>
            <button class="camCapture" (click)="capturePhoto(video)">Capture</button> &nbsp;
            <button class="camCancel" (click)="closeCamera()">Cancel</button>
            <canvas #canvas hidden></canvas>
          </div>
          <!-- Profile with camera icon ends -->

        </div>
        <div class="photo-details">
          <h6 class="photo-title">Profile Photo</h6>
          <small class="photo-hint">PNG or JPG up to 2MB</small>

          <div class="btn-group mt-2">
            <input type="file" #fileInput style="display: none" (change)="onFileChanged($event)"/>
            <button class="btn btn-outline-primary btn-sm change-btn me-3" (click)="changePhoto(fileInput)">Change</button>
            <button class="btn btn-link remove-btn btn-sm p-0" (click)="removePhoto();onDelete()">Remove</button>
          </div>

        </div>
      </div>
    </div>

    <form class="edit-form-grid" #editForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="isEditMode" novalidate>
      <!-- First Name -->
      <div class="form-group">
        <label>First Name</label>
        <input type="text" [(ngModel)]="profileData.first_name" name="firstName" #firstName="ngModel" (keydown)="preventLeadingSpace($event); preventInvalidStart($event)" (input)="validateFirstName()" placeholder="Enter Your First Name" required />
        <span class="errorStyle" *ngIf="firstName.invalid && firstName.touched">First Name is required</span>
      </div>

      <!-- Last Name -->
      <div class="form-group">
        <label>Last Name</label>
        <input type="text" [(ngModel)]="profileData.last_name" name="lastName" #lastName="ngModel" (keydown)="preventLeadingSpace($event); preventInvalidStart($event)" (input)="validateLastName()" placeholder="Enter Your Last Name" required />
        <span class="errorStyle" *ngIf="lastName.invalid && lastName.touched">Last Name is required</span>
      </div>

      <!-- Email -->
        <div class="form-group">
          <label>Email</label>
          <input type="email" [(ngModel)]="profileData.email" name="email" #email="ngModel" (keydown)="preventLeadingSpace($event)" placeholder="Enter Your Email Address" required class="disInp" [readonly]="true"/>
          <span class="errorStyle" *ngIf="email.invalid && email.touched">Email is required</span>
        </div>

      <!-- Phone Number -->
      <div class="form-group phone-input">
        <label>Phone Number</label>
        <div class="phone-wrapper">
          <div class="prefix-box">
            {{ countryMap[countryCode]?.mobile }}
          </div>
          <input type="text" [(ngModel)]="profileData.mobile" name="phone" placeholder="Enter Your Phone Number"
            inputmode="numeric" maxlength="10" pattern="[0-9]*" (keydown)="preventLeadingSpace($event)"
            (paste)="preventInvalidPaste($event)" (keypress)="allowOnlyNumbers($event)" />
        </div>
      </div>

      <!-- Gender -->
      <div class="form-group">
        <label>Gender</label>
        <select [(ngModel)]="profileData.gender" name="gender" #gender="ngModel">
          <option value="" disabled>Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="others">Others</option>
        </select>
        <!-- <span class="errorStyle" *ngIf="gender.invalid && gender.touched">Gender is required</span> -->
      </div>

      <!-- Date of Birth -->
      <div class="form-group">
        <label>Date Of Birth</label>
         <!-- <input style="cursor: pointer;" type="date" [(ngModel)]="profileData.dob" name="dob" [max]="today" #dob="ngModel" /> -->
        <input type="date" [(ngModel)]="profileData.dob" name="dob" [max]="today" [min]="'1900-01-01'" #dob="ngModel"
          style="cursor: pointer;" (click)="dobInput.showPicker()" #dobInput />
      </div>
      
      <!-- Password -->
      <div class="form-group">
        <label>Password</label>
        <input type="password" ngModel="abcdegfu" name="password" #password="ngModel" (keydown)="preventLeadingSpace($event)" placeholder="Enter Your Password" class="disInp" required/>
        <!-- <span class="errorStyle" *ngIf="password.invalid && password.touched">Password is required</span> -->
        <p class="lastChng">Last changed {{profileData?.password_last_changed}}, to change <span class="changePwd" (click)="openChangePasswordDialog()">Click Here</span></p>
      </div>

      <!-- Buttons -->
      <div class="form-actions">
        <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
        <button type="submit" class="save-btn" [disabled]="editForm.invalid">Save Changes</button>
      </div>
    </form>
  <!-- Edit Mode -->

</div>
</div>
